import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function ConfiguracaoGoogle() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const error = searchParams.get("error");
  const navigate = useNavigate();
  const XANO_BASE_URL = "https://api.sobevenda.com.br/api-proxy/affiliate";

  useEffect(() => {
  if (!code) return;

  const token = localStorage.getItem("sobevenda_token");

  if (!token) {
    console.error("Token não encontrado no localStorage.");
    navigate(
      `/google-ads?error=${encodeURIComponent(
        "Token de autenticação não encontrado."
      )}`
    );
    return;
  }

  const connectGoogle = async () => {
    try {
      const res = await fetch(`${XANO_BASE_URL}/oauth/google/callback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(
          data?.message ||
            "Não foi possível conectar a conta Google."
        );
      }

      console.log("Conta Google conectada:", data);
      navigate("/google-ads");
    } catch (err) {
      console.error("Erro ao conectar conta Google:", err);
      navigate(
        `/google-ads?error=${encodeURIComponent(
          err.message || "Erro ao conectar conta Google."
        )}`
      );
    }
  };

  connectGoogle();
}, [code, navigate]);

  return (
  <div className="p-4">
    <h1 className="text-xl font-semibold mb-2">Conectando com Google Ads...</h1>

    {error ? (
      <p className="text-red-600">{decodeURIComponent(error)}</p>
    ) : !code ? (
      <p className="text-gray-600">Aguardando o código de autenticação...</p>
    ) : (
      <p className="text-blue-600">Processando a conexão com o Google...</p>
    )}
  </div>
);
}
